module.exports = __webpack_public_path__ + "img/about_section_image.73fc2a5e.png";